import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <path d="M2 22h20V2z"></path>,
  "SignalCellular5Bar"
);
